import { RequestCommonData } from "./request-common-data";
import { RequestWaterSamplingData } from "./request-water-sampling-data";
import { WorkflowTransition } from "./workflow-transition";

export class RequestBwt {
    requestId: number;
    internalNumber: string;
    requestTypeId: number;
    requestTypeName: string;
    requestTypeKindId: number;
    requestStatusId: number;
    requestStatusName: string;
    requestCategoryId: number;
    requestCategoryName: string;
    performerUserId: number;
    performerUserName: string;
    performerUserGroupId: number;
    performerUserGroupName: string;
    createdDate: Date;
    finishDate?: Date | null;
    customerContragentId: number;
    customerContragentName: string;
    customerObjectAddress: string;
    customerObjectName: string
    customerObjectId: number;
    description: string;
    workflowTransitions: WorkflowTransition[] = [];
    utcTimezoneShiftString: string;
    utcTimezoneShift: number;
    initTypeId: number;
    initTypeName: string;
    authorUserId: number;
    authorUserName: string;
    lastActivityId: number;
    commonData: RequestCommonData;
    partnerStatusAlias: string;
	serviceCenterId: number;
	serviceCenterName: string;
	serviceCenterIntegraCode: string;
	serviceCenterSkipInventory: boolean;
    isInGroupExt: boolean;
    isGroup: boolean;
    integraCode: string;
    defaultScWarehouseName: string;
    defaultScWarehouseId: number;
    isOneRoleSC: boolean;
    paymentStatusId: number;
    paymentStatusName: string;
    paymentStatusColor: string;
    claimId: number;
    claimName: string;
    resolution: string;
    claimedDeviceQuantity: number;
	ammountOfDamage: number;
	vendorRepayment: number;
	insuranceRepayment: number;
    reclamationDeviceId: number;
    authorContragentId: number;
    authorContragentName: string;
    showInternalRequestNumber: boolean;
    autoCallingWorkflowTransitionId: number;
    carrierId: number;
    trackNumber: string;
    responsibleUserId: number;
    responsibleUserName: string;
    requestWaterSamplingData: RequestWaterSamplingData = null;
    customerContragentAddress: string;
    customerContragentAddressDescription: string;
    costCenterId: number;
    costCenterName: string;
    contragentProjectId: number;
    contragentProjectName: string;
    paymentTypeId: number;
    paymentTypeName: string;
	performerUserAutoFill: boolean;

	/** Полное редактирование: СЦ заявки совпадает с СЦ учётки. Иначе — просмотр, комментарии и смена СЦ. */
	canFullyEditRequest: boolean;

	/** Ид связанного лида (если заявка создана из лида). */
	leadId: number | null;
	/** UTM-метки связанного лида. */
	leadUtmTag: string | null;
}